import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

interface mutateProps {
  communityId: string | number,
  fiscalYear: string | number,
  checkType: string,
  data: FieldValues
}

const mutateUpdateValidationChecklist = async ({
  communityId,
  fiscalYear,
  checkType,
  data,
}: mutateProps) => {
  return await axiosAuth.patch(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}/checklist/${checkType}`, data);
};

const useUpdateValidationChecklistMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateValidationChecklist,
    ...queryParams,
  });

export default useUpdateValidationChecklistMutation;
